export default __webpack_public_path__ + "static/media/colored_lion_2.069a68ea.jpeg";